import BaseRequest from '../../components/base/base-request';
import { IAuthResult } from '../../bootstrap/updated/check-user-auth';

class LoginRequest extends BaseRequest {
    private url: string = '/auth/ajax';
    private restorePasswordUrl: string = '/security/forgotPassword';
    private resetPasswordUrl: string = '/security/resetPassword/{hash}?username={username}';
    private validateResetPasswordTokenUrl: string = '/security/validateResetPasswordToken/{hash}';

    public async authorize(
        login: string,
        password: string,
        remember: boolean
    ): Promise<IAuthResult> {
        const params = `j_username=${encodeURIComponent(login)}&j_password=${encodeURIComponent(
            password
        )}&_spring_security_remember_me=${remember}`;
        return this.rawRequest<IAuthResult>(this.url, params, {
            type: 'POST',
            contentType: 'application/x-www-form-urlencoded; charset=utf-8'
        });
    }

    public async checkAuthorization(): Promise<IAuthResult> {
        return this.rawRequest<IAuthResult>(this.url, undefined, {
            type: 'GET'
        });
    }

    public async restorePassword(login: string, emailAsLogin: boolean = false): Promise<void> {
        const params = emailAsLogin ? { email: login } : { username: login };
        return this.request<void>(this.restorePasswordUrl, params, {
            type: 'POST'
        });
    }

    public async resetPassword(
        login: string,
        securityToken: string,
        newPassword: string
    ): Promise<void> {
        const url = this.resetPasswordUrl
            .replace('{hash}', securityToken)
            .replace('{username}', encodeURIComponent(login));
        return this.request<void>(
            url,
            {
                password: newPassword
            },
            {
                type: 'POST'
            }
        );
    }

    public async registration(email: string, password: string, code: string): Promise<void> {
        const url = '/registration';
        return this.request<void>(
            url,
            {
                email,
                password,
                code
            },
            {
                type: 'POST'
            }
        );
    }

    public async activation(activationId: string): Promise<void> {
        const url = `/activation/${activationId}`;
        return this.request<void>(url, null, {
            type: 'POST'
        });
    }

    public async validateResetPasswordToken(
        token: string,
        username: string
    ): Promise<{ success: boolean }> {
        const url = this.validateResetPasswordTokenUrl.replace('{hash}', token);
        return this.rawRequest<{ success: boolean; message: string }>(
            url,
            { username },
            { type: 'GET' }
        );
    }
}

const requester = new LoginRequest();
// tslint:disable-next-line:no-default-export (autogenerated)
export default requester;
